import React, { useState } from "react"
import { createRoot } from "react-dom/client"
import { Badge, Btn, Icon } from "./groupssuite/ui"

function Preview({ src, alt }) {
  const [err, setErr] = useState(false)
  if (err || !src) {
    return (
      <div className="media-preview media-preview--placeholder">
        <Icon name="image" size={48} color="var(--ink-faint)" />
      </div>
    )
  }
  return <img className="media-preview" src={src} alt={alt || ""} loading="lazy" onError={() => setErr(true)} />
}

function MetaRow({ label, children }) {
  return (
    <div className="meta-row">
      <div className="meta-row__label">{label}</div>
      <div className="meta-row__value">{children}</div>
    </div>
  )
}

function MediaShow({ asset, translations, labels, backPath }) {
  const langs = ["de", "fr", "it", "en"]
  const firstAlt = (translations.de && translations.de.alt_text) || ""
  return (
    <section className="screen">
      <header className="screen__head">
        <div>
          <a href={backPath} className="screen__back"><Icon name="arrow_left" size={14} /> {labels.back}</a>
          <h1 className="screen__title">{(translations.de && translations.de.title) || "—"}</h1>
        </div>
        {asset.titelbild && <Badge tone="accent">{labels.titelbild_badge}</Badge>}
      </header>

      <div className="media-detail">
        <div className="media-detail__preview">
          <Preview src={asset.source_url} alt={firstAlt} />
        </div>

        <div className="media-detail__meta">
          <MetaRow label={labels.meta.domain}>{asset.domain.name} <span className="muted">({asset.domain.host})</span></MetaRow>
          <MetaRow label={labels.meta.format}>{(asset.format || "—").toUpperCase()}</MetaRow>
          <MetaRow label={labels.meta.tags}>
            <div className="badge-row">
              {(asset.tags || []).map((t) => <span key={t} className="tag-chip tag-chip--mini">{t}</span>)}
            </div>
          </MetaRow>
          <MetaRow label={labels.meta.external_listing_id}><code>{asset.external_listing_id || "—"}</code></MetaRow>
          <MetaRow label={labels.meta.source_url}>
            <a href={asset.source_url} target="_blank" rel="noreferrer" className="break-link">{asset.source_url}</a>
          </MetaRow>
        </div>
      </div>

      <h2 className="section-title">{labels.translations}</h2>
      <div className="translation-grid">
        {langs.map((loc) => (
          <div key={loc} className="translation-card">
            <div className="translation-card__lang">{labels.languages[loc]}</div>
            <div className="translation-card__field">
              <span className="translation-card__key">{labels.field_title}</span>
              <span>{(translations[loc] && translations[loc].title) || "—"}</span>
            </div>
            <div className="translation-card__field">
              <span className="translation-card__key">{labels.field_alt}</span>
              <span>{(translations[loc] && translations[loc].alt_text) || "—"}</span>
            </div>
          </div>
        ))}
      </div>

      <div className="coming-soon">
        <div className="coming-soon__title">{labels.coming_soon}</div>
        <div className="coming-soon__hint">{labels.coming_soon_hint}</div>
      </div>
    </section>
  )
}

function mount() {
  const el = document.getElementById("media-show")
  if (!el || el.dataset.mounted === "true") return
  let props = {}
  try {
    props = JSON.parse(el.dataset.props || "{}")
  } catch (error) {
    console.error("Invalid media-show props", error)
  }
  el.dataset.mounted = "true"
  createRoot(el).render(<MediaShow {...props} />)
}

document.addEventListener("turbo:load", mount)
document.addEventListener("DOMContentLoaded", mount)
